import { render, staticRenderFns } from "./goodList.vue?vue&type=template&id=25375419&scoped=true"
import script from "./goodList.vue?vue&type=script&lang=js"
export * from "./goodList.vue?vue&type=script&lang=js"
import style0 from "./goodList.vue?vue&type=style&index=0&id=25375419&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25375419",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mer_supplier_admin_Z91J/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25375419')) {
      api.createRecord('25375419', component.options)
    } else {
      api.reload('25375419', component.options)
    }
    module.hot.accept("./goodList.vue?vue&type=template&id=25375419&scoped=true", function () {
      api.rerender('25375419', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/goodList.vue"
export default component.exports